import { useSupportTokenModal } from '@/contexts/SupportTokenContext';
import { SupportTokenModal } from './SupportTokenModal';

export function GlobalSupportTokenModal() {
  const { isOpen, closeModal } = useSupportTokenModal();

  return (
    <SupportTokenModal 
      open={isOpen} 
      onOpenChange={closeModal}
    />
  );
}
